import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getPackInfoStyles = () => {
  var spacingToken = tokens.spacing;
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: spacingToken.SPACING_16
    },
    innerContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      flex: 1
    },
    planItem: {
      flexDirection: 'column',
      marginRight: spacingToken.SPACING_16
    },
    secondaryText: {
      textDecorationLine: 'line-through'
    },
    secondarySubtext: {
      marginLeft: spacingToken.SPACING_4
    },
    priceItemVerticalSpacing: {
      height: spacingToken.SPACING_2
    },
    planItemVerticalSpacing: {
      height: spacingToken.SPACING_4
    }
  });
};